import styled from '@emotion/styled'
import { FunctionComponent, useCallback } from 'react'
import { Fonts } from '~/assets/style/fonts'
import { Link } from '~/components/Link'
import { TrackingLabel } from './layout/ProductTrackingIntegration'

const Wrapper = styled.div`
  display: inline-flex;
  gap: 0.25rem;
  min-width: 0;
`

const Label = styled.span`
  white-space: nowrap;
`

const FilenamePlaceholder = styled.span`
  ${Fonts.colors.SlateGrey};
  font-style: italic;
`

type Props = {
  label: string
  filenamePlaceholder: string
  filename?: string
  trackingLabel: TrackingLabel
  isDownloading: boolean
  onDownload: (filename: string) => void
}

const BaseFileDownload: FunctionComponent<Props> = ({ label, isDownloading, filenamePlaceholder, filename, trackingLabel, onDownload }) => {
  const handleOnClick = useCallback(() => {
    if (isDownloading || !filename) return
    onDownload(filename)
  }, [filename, isDownloading, onDownload])

  return (
    <Wrapper>
      <Label>{label} -</Label>
      {filename ? (
        <Link label={filename} disabled={isDownloading} iconSpin={isDownloading} icon={isDownloading ? 'pubstack' : 'download'} onClick={handleOnClick} trackingLabel={trackingLabel} />
      ) : (
        <FilenamePlaceholder>{filenamePlaceholder}</FilenamePlaceholder>
      )}
    </Wrapper>
  )
}

export const FileDownload = styled(BaseFileDownload)``
